import React from 'react'
import List from 'components/ui/list'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
  iconNode?: React.ReactNode
}

/**
 * A list item component that displays content alongside an optional icon.
 * Wraps the standard List.Item component with enhanced styling and icon support.
 *
 * @param children - The content to display in the list item
 * @param iconNode - Optional icon or React node to display alongside the content
 * @returns A wrapped list item with icon support and custom styling
 */
const ListItemWithIcon = ({
  children,
  iconNode,
}: Props): React.ReactElement<'div'> => {
  let listItem = (
    <List.Item iconNode={iconNode} className={styles.listWithIconsItem}>
      <div className={styles.listWithIconsItemContent}>{children}</div>
    </List.Item>
  )
  return <div className={styles.listWithIconsItemWrapper}>{listItem}</div>
}

export default ListItemWithIcon
